export function filterProducts(productsArray: any[], selectedItems: any[]): any[] {
  const pickedItemIds = selectedItems.length ? selectedItems.map((item: any) => item.product) : [];
  let filteredProductsArray = productsArray;
  if(pickedItemIds.length) {
    const filterPriceBracket: boolean = productsArray.find((product: any) => product._id == pickedItemIds[0])?.allowPriceBracket;
    filteredProductsArray = productsArray.filter((product: any) => {
      if(filterPriceBracket) {
        return product.allowPriceBracket;
      } else {
        return !product.allowPriceBracket && !pickedItemIds.includes(product._id);
      }
    });
  }
  return filteredProductsArray.map((product: any) => {
    if(!product.priceBracket) {
      return { ...product, priceBracket: [] };
    }
    return product;
  });
}
